import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2, Radio } from 'lucide-react';

export const LoadBoardCTA = () => (
  <section className="relative py-24 overflow-hidden" style={{ fontFamily: 'Outfit, sans-serif' }}>
    <div
      className="absolute inset-0 bg-cover bg-center"
      style={{ backgroundImage: `url('https://static.prod-images.emergentagent.com/jobs/67b0925b-7f4b-4cc2-900d-1c317dc2d0bd/images/dd0baf8fc28a2650877bb16f546fc3bd2e62b6be96a6836b45f6409c0beab942.png')` }}
    />
    <div className="absolute inset-0 bg-black/80" />

    <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <div className="flex items-center gap-2 mb-4">
            <Radio className="w-4 h-4 text-red-500 animate-pulse" />
            <span className="text-red-500 text-xs font-bold uppercase tracking-[0.25em]">Live Now</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-black text-white tracking-tight mb-4">
            Carriers: Access the<br />Live Load Board
          </h2>
          <p className="text-zinc-400 text-lg mb-8 max-w-lg" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
            Browse available freight, get matched to loads in your lanes, and grow your business. 
            Competitive rates and prompt payment on every load.
          </p>
          <div className="grid sm:grid-cols-2 gap-3 mb-8">
            {['Competitive Rates', 'Prompt Payment', '24/7 Live Dispatch', 'Nationwide Lanes'].map(item => (
              <div key={item} className="flex items-center gap-2">
                <CheckCircle2 className="w-4 h-4 text-red-500 flex-shrink-0" />
                <span className="text-zinc-300 text-sm font-medium">{item}</span>
              </div>
            ))}
          </div>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/load-board"
              className="inline-flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 text-white px-8 py-4 font-bold uppercase tracking-wider text-sm transition-all hover:-translate-y-0.5"
              data-testid="loadboard-cta-btn"
            >
              View Available Loads
              <ArrowRight className="w-4 h-4" />
            </Link>
            <Link
              to="/carrier"
              className="inline-flex items-center justify-center gap-2 border border-zinc-600 text-zinc-300 hover:border-white hover:text-white px-8 py-4 font-bold uppercase tracking-wider text-sm transition-colors"
              data-testid="carrier-register-cta-btn"
            >
              Register as Carrier
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
